import { REPORTS_MEDICINE_WISE_STOCK_AUDIT } from "../../framework/tab/tabUtilsConstants";
import moment from "moment";
import { dateFilterComparator } from "../../utils/utils";
export const columnDefs = [
  {
    headerName: "Medicine Wise Stock Audit ID",
    field: "stockAuditId",
    width: 150,
    hide: true,
  },
  {
    headerName: "Branch Code",
    field: "branchCode",
    width: 150,
  },
  {
    headerName: "Branch Name",
    field: "branchName",
    width: 150,
  },
  {
    headerName: "Medicine Name",
    field: "medicineName",
    width: 150,
  },
  {
    headerName: "Packaging",
    field: "medicinePackaging",
    width: 150,
  },
  {
    headerName: "Batch Number",
    field: "batchNumber",
    width: 150,
  },
  {
    headerName: "Barcode",
    field: "barcode",
    width: 150,
  },
  {
    headerName: "Expiry",
    field: "expiry",
    width: 150,
  },
  {
    headerName: "Audit Request ID",
    field: "stockAuditRequestId",
    width: 150,
  },
  {
    headerName: "Stock Audit Request Date and time",
    field: "stockAuditRequestCreatedTime",
    width: 150,
  },
  {
    headerName: "Store Stock Audit Id",
    field: "stockAuditId",
    width: 150,
  },
  {
    headerName: "Store Stock Audit Date and time",
    field: "businessDate",
    width: 150,
  },
  {
    headerName: "Audited By",
    field: "auditor",
    width: 150,
  },
  {
    headerName: "Actual quantity",
    field: "expectedQuantity",
    width: 150,
  },
  {
    headerName: "CP Total (Actual)",
    field: "totalExpectedCostPrice",
    width: 150,
  },
  {
    headerName: "Eff. CP Total (Actual)",
    field: "expectedEffectiveCostPrice",
    width: 150,
  },
  {
    headerName: "MRP Total( Actual)",
    field: "totalExpectedMrp",
    width: 150,
  },
  {
    headerName: "Audited quantity",
    field: "actualQuantity",
    width: 150,
  },
  {
    headerName: "CP Total (Audited)",
    field: "totalAuditedCostPrice",
    width: 150,
  },
  {
    headerName: "Eff. CP Total (Audited)",
    field: "actualEffectiveCostPrice",
    width: 150,
  },
  {
    headerName: "MRP Total( Audited)",
    field: "totalAuditedMrp",
    width: 150,
  },
  {
    headerName: "Variance quantity",
    field: "quantityVariance",
    width: 150,
  },
  {
    headerName: "CP Total( variance)",
    field: "costPriceVariance",
    width: 150,
  },
  {
    headerName: "Eff. CP Total( variance)",
    field: "effectiveCostPriceVariance",
    width: 150,
  },
  {
    headerName: "MRP Total( variance)",
    field: "mrpVariance",
    width: 150,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    width: 150,
  },
];
export const columnDefsFunctions = {
  expiry: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  stockAuditRequestCreatedTime: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
  businessDate: {
    valueFormatter: (params) => {
      return params.value
        ? moment(`${params.value}`).format("DD/MM/YYYY hh:mm A")
        : "";
    },
    filterParams: {
      comparator: (filterValue, cellValue) =>
        dateFilterComparator(filterValue, cellValue, "DD/MM/YYYY"),
      browserDatePicker: true,
    },
  },
};

export const initial_state_medicine_wise_stock_audit_report = {
  type: REPORTS_MEDICINE_WISE_STOCK_AUDIT,
  label: "Medicine Wise Stock Audit Report",
  allowMultipleTabs: false,
};
